class SophiAPI {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}/sophi/sophiserpresult`;
    }

    async getSophi(query = '', timeoutSeconds) {
        try {
            const { data } = await this.http.get(this.path, {
                ...(Number.isFinite(timeoutSeconds) && timeoutSeconds > 0
                    ? {
                          timeout: timeoutSeconds * 1000,
                      }
                    : {}),
                ...(typeof query === 'string' && {
                    params: {
                        query,
                    },
                }),
            });
            const { success, preemptive_queries, message } = data || {};
            const preemptiveQueries = Array.isArray(preemptive_queries)
                ? preemptive_queries.reduce((all, next) => {
                      if (typeof next === 'string' && next.trim().length) {
                          all.push({ label: next });
                      }
                      return all;
                  }, [])
                : null;
            return { success, preemptiveQueries, message };
        } catch (e) {
            return { failedRequest: true };
        }
    }
}

export default SophiAPI;
